// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.

import * as _ from 'lodash';
import { IPageData, pageData } from 'src/app/features/page/models/page-data';
import { isEmptyObject } from 'src/app/infrastructure/functions/is-empty-object.function';
import { ILevelGeneralDto } from 'src/app/infrastructure/models/level-general-dto';
import { activityDto, ActivityDto, IActivityDto } from './activity-dto.g';
import { IActivityRefDto } from './activity-ref-dto.g';

export const pageDto = {
    guid: 'guid',
    nr: 'nr',
    name: 'name',
    displayName: 'displayName',
    isTab: 'isTab',
    inactive: 'inactive',
    deleted: 'deleted',
    activitiesDto: 'activitiesDto',
} as const;

export type TPageDto = (typeof pageDto)[keyof typeof pageDto];

export const pageDtoConstraints = {
    name: { required: true, maxLength: 40 },
    displayName: { maxLength: 40 },
} as const;

export type TPageDtoConstraints = typeof pageDtoConstraints;

export interface IPageDto extends ILevelGeneralDto {
    [pageDto.guid]: string | null;
    [pageDto.nr]: number | null;
    [pageDto.name]: string | null;
    [pageDto.displayName]: string | null;
    [pageDto.isTab]: boolean | null;
    [pageDto.inactive]: boolean | null;
    [pageDto.deleted]: boolean | null;
    [pageDto.activitiesDto]: IActivityRefDto[] | null;
}

export class PageDto
    implements IPageDto
{
    [pageDto.guid]: string | null = null;
    [pageDto.nr]: number | null = null;
    [pageDto.name]: string | null = null;
    [pageDto.displayName]: string | null = null;
    [pageDto.isTab]: boolean | null = null;
    [pageDto.inactive]: boolean | null = null;
    [pageDto.deleted]: boolean | null = null;
    [pageDto.activitiesDto]: IActivityRefDto[] | null = null;

    private constructor(
        modelData?: IPageData
    ) {
        if (!modelData || isEmptyObject(modelData)) return;

        this[pageDto.guid] = modelData[pageData.guid];
        this[pageDto.nr] = modelData[pageData.nr];
        this[pageDto.name] = modelData[pageData.name];
        this[pageDto.displayName] = modelData[pageData.displayName];
        this[pageDto.isTab] = modelData[pageData.isTab];
        this[pageDto.deleted] = modelData[pageData.deleted];
        this[pageDto.inactive] = modelData[pageData.inactive];

        this[pageDto.activitiesDto] = modelData[pageData.activitiesData]
            ?.map(item => ActivityDto.create(item, false))
            .filter((a): a is IActivityDto => a !== null)
            .sort((a, b) => (a[activityDto.name] ?? '').localeCompare(b[activityDto.name] ?? ''))
            ?? null;
    }

    static create(modelData?: IPageData | null): IPageDto | null {
        return modelData ? new PageDto(modelData) : null;
    }
}
